import PublicLayout from './layouts/PublicLayout';
import { RouterProvider, createBrowserRouter, Navigate } from 'react-router-dom'
import { getLocale, isUserLoggedIn } from './utils';
import LoginPage from 'features/auth/login';
import AdminLayout from './layouts/AdminLayout';
import NotFound from './features/misc/NotFound';
import Admin from './features/admin';
import Shops from './features/shops';
import Users from './features/users';
import { useEffect } from 'react';
import { setUiLocale } from 'app/i18n';
import { ConfigProvider } from 'antd';
import { useTranslation } from 'react-i18next';
import RevenuePage from 'features/revenue';
import IngredientPage from 'features/sushi/pages/ingredient';
import BoxPage from 'features/sushi/pages/box';
import Netto from 'features/netto';
import ComputeSushi from 'features/sushi';
import InventoryPage from 'features/inventory';
import Notification from 'features/notification';
function App() {

  useEffect(() => {
    setUiLocale(getLocale() || process.env.REACT_APP_DEFAULT_LOCALE)
  }, [])

  const { t } = useTranslation()

  const router = createBrowserRouter([
    {
      path: "/",
      element: !isUserLoggedIn() ? <Navigate to='/login' /> : <Navigate to='/admin/timesheet' />,
    },
    {
      path: "/login",
      element: <PublicLayout />,
      children: [
        {
          index: true,
          element: <LoginPage />
        }
      ]
    },
    {
      path: "/admin",
      element: <AdminLayout />,
      children: [
        {
          path: "timesheet",
          element: <Admin />
        },
        {
          path: "users",
          element: <Users />
        },
        {
          path: "shops",
          element: <Shops />
        },
        {
          path: "ingredients",
          element: <IngredientPage />
        },
        {
          path: "boxes",
          element: <BoxPage />
        },
        {
          path: "calculator-sushi",
          element: <ComputeSushi />
        },
        {
          path: "revenues",
          element: <RevenuePage />
        },
        {
          path: "inventory",
          element: <InventoryPage />
        },
        {
          path: "netto",
          element: <Netto />
        },
        {
          path: "notification",
          element: <Notification />
        },
      ]
    },
    {
      path: "*",
      element: <NotFound />
    }
  ]);

  return (
    <ConfigProvider form={{
      validateMessages: {
        required: t('required')
      }
    }}>
      <RouterProvider router={router} />
    </ConfigProvider>
  )
}

export default App
